
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import { AsrItem, AsrItemGroup } from "@/lib/model/exam/result";
import SvgImgV3 from "@/components/videoPaly/video-play-v3.vue";
import {
  MessageConfig,
  MessageRoleEnum
} from "@/lib/model/exam/candidate-result";

@Component({
  components: {
    ModalHeader,
    SvgImgV3
  }
})
export default class CandidateAnswerSection extends Vue {
  name = "candidate-answer-section";
  @Prop() answer!: MessageConfig;
  @Prop() append!: MessageConfig[];
  @Prop() answerIndex!: number;
  @Prop() active!: boolean;
  @Prop() pdfIng!: boolean;
  @Prop({ default: -1 }) currentActiveIndex!: number; //正在播放的追问视频 [questionIndex, appendIndex]
  highLightIndex = -1;

  isIphone = false;

  playTime = 0;

  //全屏视频修改填充样式
  isVideoFullscreen = false;
  get objectFit() {
    return this.isVideoFullscreen ? "contain" : "cover";
  }
  checkFullscreen() {
    this.isVideoFullscreen =
      document.fullscreenElement !== null &&
      document.fullscreenElement.tagName === "VIDEO";
  }

  // mp3不展示居中播放按钮
  isShowSvg(val: string) {
    return (
      val &&
      String(val)
        .substr(-3, 3)
        .toLowerCase() !== "mp3"
    );
  }

  // 自动播放下一个追问
  onEnded(appendQuestionIndex?: number) {
    const questionLen = this.append.length;

    if (!questionLen) return;
    const appendIndex = appendQuestionIndex || this.currentActiveIndex;
    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem(
        this.append[appendIndex + 1].asrTextList[0],
        appendIndex + 1
      );
    }
  }

  timeupdate({ target }: Event) {
    this.playTime = (target as HTMLMediaElement).currentTime * 1000;
    // this.lastPlayVideoIndex = answerIndex;
    this.$emit("timeupdate", { target });
  }

  @Watch("playTime")
  onPlayTimeChange(to: any, from: any) {
    this.answer.asrTextList.forEach(item => {
      item.highLight =
        to >= item.bg && to <= item.ed && this.currentActiveIndex === -1;
    });
    this.append.forEach((item, i) => {
      item.asrTextList.forEach(d => {
        d.highLight = to >= d.bg && to <= d.ed && this.currentActiveIndex === i;
      });
    });
  }

  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }

  onClickAsrItem(asrItem: AsrItem, appendIndex = -1) {
    console.log(appendIndex);
    this.$emit("on-click-asr-item", {
      appendIndex: appendIndex,
      time: asrItem.bg
    });
  }
}
